import { RewardItem, exportRewardItem } from './components/RewardItem'
import util from 'util'
import { Fixed8 } from '../utils'

/**
 * @class Rewards
 * @classdesc
 * Rewards object used for getting reward of MODC.
 * @param {Rewards} config - Rewards-like object
 * @param {string} config.net - Network
 * @param {string}  config.address - The address for this Rewards
 * @param {RewardItem[]} config.rewards - The list of rewards to be made.
 */
class Rewards {
  constructor (config = {}) {
    /** The address for this Rewards */
    this.address = config.address || ''
    /** Network which this Rewards is using */
    this.net = config.net || 'NoNet'
    /** Total rewards */
    this.reward = config.reward || new Fixed8(0)
    /** The list of getting rewards of file contract transactions */
    this.rewards = config.rewards ? config.rewards.map(c => RewardItem(c)) : []
  }

  get [Symbol.toStringTag] () {
    return 'Rewards'
  }

  [util.inspect.custom] (depth, opts) {
    const rewardsDump = this.rewards.map(c => {
      return `${c.fileContractHash}: ${c.rewards.toString()}`
    })
    return `[Rewards(${this.net}): ${this.address}]\n${JSON.stringify(rewardsDump, null, 2)}`
  }

  export () {
    return {
      address: this.address,
      net: this.net,
      reward: this.reward,
      rewards: this.rewards.map(exportRewardItem)
    }
  }

  /**
   * Returns a Rewards object that contains part of the total rewards starting at [[start]], ending at [[end]].
   * @param {number} start
   * @param {number} [end] - Optional.
   * @return {Rewards}
   */
  slice (start, end = undefined) {
    return new Rewards({
      address: this.address,
      net: this.net,
      reward: this.reward,
      rewards: this.rewards.slice(start, end)
    })
  }
}

export default Rewards
